export enum VerificationResult {
  SESSIONEXPIRED = 'SESSIONEXPIRED',
  TEMP_PASSWORD = 'TEMP_PASSWORD',
  VERIFY = 'VERIFY',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  LOCKEDOUT = 'LOCKEDOUT',
  TRUSTED = 'TRUSTED',
  SUSPENDED = 'SUSPENDED',
  AUTHENTICATED = 'AUTHENTICATED',
  NOACTIVEACCOUNTS = 'NOACTIVEACCOUNTS'
}
